/**
 * Radia slider.
 * @param el
 * @param options
 * @constructor
 */
const RadialSlider = function (el, options = {}) {
	const _ = this;

	/**
	 * RadialSlider init.
	 */
	const init = function () {
		_.slider = el;
		_.items = Array.from(el.children);
		_.settings = {
			namespace: 'radial-slider',
			radius: 1200,
			deltaFactor: 0.05,
			deltaFactorTouch: 0.002,
			preRotateFactor: 0.8,
			inViewDegree: 40,
			itemAngle: false,
			stop: true,
			stopAngle: 40,
			mediaQueries: [
				{
					media: 'screen and (max-width: 75em)',
					itemAngle: false,
				}
			]
		};
		_._bumpEvent = new CustomEvent('radialSliderBump', {
			detail: {
				RadialSlider: _,
			}
		});
		_._xTouchDown = null;
		_._yTouchDown = null;

		if (options) {
			_.settings = _.mapOptions(_.settings, options);
		}

		_.settings.inViewDegreeLower = _.settings.inViewDegree / -2;
		_.settings.inViewDegreeUpper = _.settings.inViewDegree / 2;

		_.preRotAngle = 45 * _.settings.preRotateFactor;
		_.preRotAbsoluteAngle = 360 - _.preRotAngle;

		_.itemDegree = _.getItemDegrees();
		_._sliderRotation = _.settings.inViewDegreeLower;

		_.wrapper = document.createElement('div');
		_.wrapper.classList.add(_.getNamespace('-wrapper'));
		_.slider.parentNode.appendChild(_.wrapper);
		_.wrapper.appendChild(_.slider);

		_.slider.classList.add(_.getNamespace());

		_._maxFirstItemDegree = _.settings.stopAngle / -2;
		_._maxLastItemDegree = _._maxFirstItemDegree - (_.getItemDegrees() * (_.items.length - 1) - (_.settings.stopAngle));

		_._setSlideMarkups();
		_._setOrigins();
		_._setTransforms();

		_.slider.addEventListener('wheel', _._scrollWheelListener);
		document.addEventListener('touchstart', _._touchStartListener, false);
		document.addEventListener('touchend', _._touchEndListener, false);
		_.slider.addEventListener('touchmove', _._touchMoveListener, false);

		_.slider.addEventListener('radialSliderBump', _._radialSliderBumpListener);
	};

	/**
	 * Listen for basic scroll events.
	 * @param e
	 * @private
	 */
	_._scrollWheelListener = function (e) {
		e.preventDefault();

		window.requestAnimationFrame(_.slide.bind(_, e.deltaY * _.settings.deltaFactor));
		// _.slide(e.deltaY * _.settings.deltaFactor);
	};

	_.slide = function (intDelta) {
		_._sliderRotation = _.getSliderRotationByDelta(intDelta);

		_._setTransforms();
	};

	_._touchStartListener = function (e) {
		const firstTouch = _._getTouches(e)[0];
		_._xTouchDownFirst = firstTouch.clientX;
	};

	_._touchEndListener = function (e) {
		_._xTouchDownLast = null;
	};

	_._touchMoveListener = function (e) {
		if (_._xTouchDownFirst == null) {
			return;
		}

		var xUp = e.touches[0].clientX;

		let xTouchDiff = _._xTouchDownFirst - xUp;

		let touchDelta = (xTouchDiff * _.settings.deltaFactorTouch) * -1;

		window.requestAnimationFrame(_.slide.bind(_, touchDelta));
	};

	_._radialSliderBumpListener = function (e) {
		let strBumpClass;
		let el = e.target;
		let objStyles = getComputedStyle(el);
		let floatDelay = parseFloat(objStyles.transitionDuration) * 1000;

		if (e.detail.RadialSlider.bump.side == 'left') {
			strBumpClass = _.getNamespace('--bumped-left');
		} else {
			strBumpClass = _.getNamespace('--bumped-right');
		}

		el.classList.add(strBumpClass);

		setTimeout(function () {
			el.classList.remove(strBumpClass);
		}, floatDelay);
	};

	_._getTouches = function (e) {
		return e.touches;
	};

	_.getSliderRotationByDelta = function (intDelta) {
		let intSliderRotation = _._sliderRotation + intDelta;

		if (_.settings.stop && (intSliderRotation > _._maxFirstItemDegree || intSliderRotation < _._maxLastItemDegree)) {
			_.bump = {};

			if (intSliderRotation > _._maxFirstItemDegree) {
				_.bump.side = 'left';

				intSliderRotation = _._maxFirstItemDegree;
			} else {
				_.bump.side = 'right';

				intSliderRotation = _._maxLastItemDegree;
			}

			_.slider.dispatchEvent(_._bumpEvent);
		} else {
			_.bump = null;
		}

		return intSliderRotation;
	};

	/**
	 * Get pre rotation value.
	 * @param intRot
	 * @returns {number}
	 * @private
	 */
	_._getPreRotation = function (intRot) {
		let intNewRot;
		let intRotAbsValue;

		if (intRot > -45 && intRot < 45) {
			intRotAbsValue = (Math.abs(intRot) % _.preRotAbsoluteAngle);

			intNewRot = (-1 * intRot * (intRotAbsValue / _.preRotAngle));
		} else {
			intNewRot = 0;
		}
		return intNewRot;
	};

	/**
	 * Set transform origins on all items.
	 * @private
	 */
	_._setOrigins = function () {
		_.items.forEach(_._setOriginOnItem);
	};

	/**
	 * Set basic markup on all slides.
	 * @private
	 */
	_._setSlideMarkups = function () {
		_.items.forEach(_._setItemWrappers);
		_.items.forEach(_._setItemClass);
	};

	/**
	 * Set transform on all items.
	 * @private
	 */
	_._setTransforms = function () {
		_.items.forEach(_._setItemTransform);
	};

	/**
	 * Set transform origin on single item.
	 * @param el
	 * @private
	 */
	_._setOriginOnItem = function (el) {
		let elHeight = el.offsetHeight;
		el.style.setProperty('transform-origin', '50% ' + (elHeight + _.settings.radius) + 'px');
	};

	/**
	 * Set the transform in single item.
	 * @param el
	 * @param i
	 * @returns {number}
	 * @private
	 */
	_._setItemTransform = function (el, i) {
		let intItemDegree = ((i) * _.itemDegree + _._sliderRotation) % 360;

		if (intItemDegree > 90) {
			intItemDegree = intItemDegree - 360;
		}

		if (intItemDegree > _.settings.inViewDegreeLower && intItemDegree < _.settings.inViewDegreeUpper) {
			el.parentNode.classList.add(_.getNamespace('__slide-outer--in-view-angle'));
		} else {
			el.parentNode.classList.remove(_.getNamespace('__slide-outer--in-view-angle'));
		}

		let intPreRotation = _._getPreRotation(intItemDegree);
		let elInner = el.querySelector(_.getNamespaceClass('__slide-inner'));

		if (intItemDegree > -45 && intItemDegree < 45) {
			el.parentNode.classList.add(_.getNamespace('__slide-outer--in-view'));
		} else {
			el.parentNode.classList.remove(_.getNamespace('__slide-outer--in-view'));
		}

		elInner.style.setProperty('transform', 'rotate(' + intPreRotation + 'deg)');
		el.style.setProperty('transform', 'rotate(' + intItemDegree + 'deg)');

		if (i == 0) {
			_.firstItemDegree = intItemDegree;
		}

		if (i == _.items.length - 1) {
			_.lastItemDegree = intItemDegree;
		}

		return intItemDegree;
	};

	/**
	 * Set wrappers on single item.
	 * @param el
	 * @private
	 */
	_._setItemWrappers = function (el) {
		let elWrapper = document.createElement('div');
		elWrapper.classList.add(_.getNamespace('__slide-outer'));

		let elWrapperInner = document.createElement('div');
		elWrapperInner.classList.add(_.getNamespace('__slide-inner'));

		elWrapperInner.innerHTML = el.innerHTML;
		el.innerHTML = elWrapperInner.outerHTML;

		el.parentNode.appendChild(elWrapper);
		elWrapper.appendChild(el);
		el.classList.add(_.getNamespace('__slide'));
	};

	/**
	 * Set class on single item.
	 * @param el
	 * @private
	 */
	_._setItemClass = function (el) {
		el.classList.add(_.getNamespace('__slide'));
	};

	/**
	 * Get degrees between items.
	 * @returns {boolean|number}
	 */
	_.getItemDegrees = function () {
		if (_.settings.itemAngle) {
			return _.settings.itemAngle;
		} else {
			return 360 / _.items.length;
		}
	};

	/**
	 * Get namespace of current instance.
	 * @param strSuffix
	 * @param strPrefix
	 * @returns {string}
	 */
	_.getNamespace = function (strSuffix = '', strPrefix = '') {
		return _.settings.namespace + strSuffix;
	};

	/**
	 * Get namespace CSS class of current instance.
	 * @param strSuffix
	 * @param strPrefix
	 * @returns {string}
	 */
	_.getNamespaceClass = function (strSuffix, strPrefix) {
		return '.' + _.getNamespace(strSuffix, strPrefix);
	};

	/**
	 * Map options of two arrays.
	 * @param settings
	 * @param options
	 * @returns {*}
	 */
	_.mapOptions = function (settings, options) {
		Object.keys(options).forEach((strKey) => {
			if (typeof options[strKey] == 'object') {
				settings[strKey] = _.mapOptions(settings[strKey], options[strKey]);
			} else {
				settings[strKey] = options[strKey];
			}
		});

		return settings;
	};

	init();
};

export default RadialSlider;
